<template>
  <div>
    <Header />
      <!-- <scroller height="100%" :on-refresh="refresh" :on-infinite="infinite" ref="my_scroller" > -->
        <ul class="art-list-pic">
          <li v-html="content"></li>
        </ul>
      <!-- </scroller> -->
      <div class="mask" v-if="loading">
        <div class="sub">
          <img src="@/assets/img/Spinner-1s-50px.svg" alt="">
        </div>
      </div>
    <!-- 底部 -->
    <Concatc  />
  </div>
</template>

<script>
import Header from '@/components/header/header';
import Concatc from '@/components/concatc/concatc';
import Vue from 'vue';
// import VueScroller from "vue-scroller";
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';
// Vue.use(VueScroller);
export default {
  components: {
    Header,
    Concatc
  },
  data() {
    return{
      currentPage:1,
      isBottom:[],
      loading:true,
      content:'',
    }
  },
   created() {
     this.getVideoInfo();
  },
  methods: {
    infinite(done){//上拉加载
      if(this.isBottom){//当没有更多数据的时候结束加载
        this.loadingTips ="无更多数据..."
        setTimeout(()=>{
          done&&done(true);
          this.$refs.my_scroller.resize()
        },1000);
      }else{//有更多数据时进行数据分页显示
        setTimeout(() => {
          this.currentPage++;
          // this.getDataList(this.currentPage);
          this.$nextTick(() => {
            // this.$refs.my_scroller.reset()
          })
        },1500)
      }
    },
    // 获取插画列表
    getVideoInfo(){
      let url = CONSTANT.ARTINSRT.FINDVAL;
      common.postNoSess(url, null,null, res => {
        console.log(res);
        this.content = res.data.bussData;
        this.loading = false;
      })
    },
  },

}
</script>

<style lang="less" scope>
  ._v-container[data-v-ecaca2b0]{
   position: relative;
   overflow: hidden;
  }
  .mask{
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height:100%;
    background: rgba(0,0,0,.5);
    .sub{
       img{
        width:80px;
        height: 80px;
      }
      margin-top:50%;
      text-align: center;
      p{
        font-size:26px;
        color: #fff;
      }
    }
  }
  .art-list-pic{
    padding-bottom: 30px;
    li{
      margin-bottom: 8px;
      p{
        height:100%;
        width:100%;
        img{
          height:100%;
          width:100% !important;
        }
      }

    }
  }

</style>
